// import React from "react";

// import "./twoFactorQrCode.scss";

const TwoFactorQrCode = ({ handlecancel, handleSave }) => {
  const isMobile = useScreenMobile({ size: 992 });
  

  return isMobile ? (
    <div className="twoFactor">
      <Drawer
        isVisible={true}
        handleCancel={handlecancel}
        showFooter={false}
        heading="Update Two Factor Authenticator"
        handleSave={handleSave}
        showHeader={false}
        customHeader={true}
        closable={false}
      >
        <QrCode handleSave={handleSave} />
      </Drawer>
    </div>
  ) : (
    <div className="twoFactor">
      <Modal
        heading="Update Two Factor Authenticator"
        showFooter={false}
        handleCancel={handlecancel}
        handleSave={handleSave}
        showCross={false}
        showHeader={false}
        customHeader={true}
        closable={false}
      >
        <QrCode handleSave={handleSave} />
      </Modal>
    </div>
  );
};

export default TwoFactorQrCode;

import { useContext, useEffect, useState } from "react";
// import qr from "assets/images/authenticate/qr.svg";
// import qrDark from "assets/images/authenticate/qrDark.svg";
import ms from "assets/images/authenticate/microsoft.svg";
import google from "assets/images/authenticate/google.svg";
import copy from "assets/images/authenticate/copy.svg";
import copyDark from "assets/images/authenticate/copyDark.svg";

import useTheme from "hooks/observer";
import "./twoFactorQrCode.scss";
import "containers/AuthenticationPage/authentication.scss";
import { signupContext } from "context/SignupContext";
import { QRCodeCanvas } from "qrcode.react";
import Button from "components/Button/index";
import Drawer from "components/Drawer/index";
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
// import init, { UserSettings } from "Wasm/izwasm.js";
import { ManageUser as MU } from "@induz/sdk";


const QrCode = ({ nextStep, handleSave }) => {
  const { qrData: contextQrData } = useContext(signupContext);
  
  const [qrData, setQrData] = useState(contextQrData || "");
  const [showQr, setShowQr] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const [copyText, setCopyText] = useState("");

  const theme = useTheme();
  const copyCode = theme === "light" ? copy : copyDark;

  // Function to extract secret from OTP Auth URL
  const extractSecret = (otpAuthUrl) => {
  if (!otpAuthUrl) return null;

  try {
    // Extract the query string portion after the "?" in the otpauth URL
    const queryStartIndex = otpAuthUrl.indexOf("?");
    if (queryStartIndex === -1) return null;

    const queryString = otpAuthUrl.slice(queryStartIndex + 1);
    const params = new URLSearchParams(queryString);

    // Extract the 'secret' parameter
    const secret = params.get("secret");
    return secret;
  } catch (error) {
    console.error("Failed to extract secret:", error);
    return null;
  }
};


  useEffect(() => {
    const generateQRCode = async () => {
      setShowQr(true);
      setIsLoading(true);
      try {
        const totpkey = await MU.resetTotp();
        setQrData(totpkey);
        const secretValue = extractSecret(totpkey);
        if (secretValue) setCopyText(secretValue);
      } catch (error) {
        console.error("Failed to generate QR code:", error);
        // Fallback to context data if available
        if (contextQrData) {
          setQrData(contextQrData);
          const secretValue = extractSecret(contextQrData);
          if (secretValue) setCopyText(secretValue);
        }
      } finally {
        setIsLoading(false);
      }
    };

    generateQRCode();
  }, [contextQrData]);

  // Reset copied state after 3 seconds
  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  const handleCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(copyText);
  };

  return (
    <>
      <div className="modalContainers">
        <div className="qrResponse">
          <p className="text">{showQr ? "Scan QR Code" : "Enter the code"}</p>
          {showQr ? (
            <div className="qr">
              {isLoading ? (
                <div className="loading">
                  <p>Loading QR code...</p>
                </div>
              ) : (
                <QRCodeCanvas value={qrData} size={180} />
              )}
            </div>
          ) : (
            <div className="code">
              <div className="codeBox">
                <p>{copyText}</p>
              </div>
              {!copied && (
                <div className="copy" onClick={handleCopy}>
                  <span className="tooltip">{copied ? "Copied" : "Copy"}</span>
                  <img src={copyCode} alt="copy" />
                </div>
              )}
              {copied && (
                <div className="copied">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M4.66602 9.99967L8.83268 14.1663L17.166 5.83301"
                      stroke="#339A33"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="tooltip">{copied ? "Copied" : "Copy"}</span>
                </div>
              )}
            </div>
          )}
          {<p className="switch" onClick={() => setShowQr((pre) => !pre)}>
            {showQr ? "Enter Code Manually" : "Scan QR code"}
          </p>}
        </div>
        <div className="steps">
          <div className="step">
            <p>Step 1</p>
            <div className="suggestion">
              <div className="text">
                <p>
                  Install the Google or Microsoft authenticator in your mobile
                </p>
              </div>
              <div className="authenticators">
                <div className="box">
                  <img src={google} alt="logo" className="logo" />
                  <p className="type">Google authenticator</p>
                </div>
                <div className="box">
                  <img src={ms} alt="logo" className="logo" />
                  <p className="type">Microsoft authenticator</p>
                </div>
              </div>
            </div>
          </div>
          <div className="step step2">
            <p>Step 2</p>
            <div className="suggestion">
              <div className="text">
                <p>
                  Open the scanner in the authenticator application and scan the
                  QR shown below{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Button title="Proceed" type="violet" onClick={handleSave} />
      </div>
    </>
  );
};
